export default "__VITE_ASSET__db43a8da__"